import type { z } from 'zod';

import type { SlackConfigSchema } from './schemas';

type SlackConfigField = keyof z.infer<typeof SlackConfigSchema>;

const listAttributes = [
  'slackUserId',
  'karma',
  'celebrated',
] as const satisfies readonly SlackConfigField[];
const getAttributes = [...listAttributes] as const satisfies readonly SlackConfigField[];
const updateAttributes = ['celebrated'] as const satisfies readonly SlackConfigField[];

export const SlackConfigAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
